"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
interface StepperProps {
  currentStep: number;
  totalSteps: number;
}
export function Stepper(t0) {
  const $ = _c(5);
  const {
    currentStep,
    totalSteps
  } = t0;
  let t1;
  if ($[0] !== currentStep || $[1] !== totalSteps) {
    let t2;
    if ($[3] !== currentStep) {
      t2 = (_, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber <= currentStep;
        return <div key={stepNumber} className={cn("h-2 rounded-full transition-all duration-300 ease-out", "flex-1", isActive ? "bg-primary-600 shadow-sm" : "bg-neutral-200 hover:bg-neutral-250")} />;
      };
      $[3] = currentStep;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = <div className="pt-2 pb-4 px-3"><div className="flex items-center gap-2">{Array.from({
          length: totalSteps
        }, t2)}</div></div>;
    $[0] = currentStep;
    $[1] = totalSteps;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}